module.exports = __webpack_public_path__ + "img/__granite.e83166da.jpg";